<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col>
            <rest-form-item
              :label="$t('ChannelConfig_ChooseGateway')"
              prop="channel"
              v-if="isCreatePage"
            >
              <enum-select
                v-model="model.channel"
                :placeholder="$t('ChannelConfig_ChooseGateway')"
                :options="channelOptionLabel"
                :number="false"
              />
            </rest-form-item>

            <component
              :is="channelOptionComponentName[model.channel]"
              :model="model"
            />
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import {
  channelOptionComponentName,
  channelOptionLabel
} from '@/modules/channels/enum/ChannelEnums'
import DummySms from '@/modules/channels/providers/DummySms'
import Facebook from '@/modules/channels/providers/Facebook'
import MessageBird from '@/modules/channels/providers/MessageBird'
import MessageBirdWhatsapp from '@/modules/channels/providers/MessageBirdWhatsapp'
import Mitto from '@/modules/channels/providers/Mitto'
import Mobivate from '@/modules/channels/providers/Mobivate'
import Phonovation from '@/modules/channels/providers/Phonovation'
import Ssc from '@/modules/channels/providers/Ssc'
import Tola from '@/modules/channels/providers/Tola'
import Twilio from '@/modules/channels/providers/Twilio'
import Vonage from '@/modules/channels/providers/Vonage'
import SmsStudio from '@/modules/channels/providers/SmsStudio'
import Sinch from '@/modules/channels/providers/Sinch'
import Smpp from '@/modules/channels/providers/Smpp'
import EngageHub from '@/modules/channels/providers/EngageHub'
import Eyou from '@/modules/channels/providers/Eyou'
import RestFormPage from '@/common/components/rest/RestFormPage'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import EnumSelect from '@/common/components/form/EnumSelect'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'ChannelFormPage',

  components: {
    RestFormPage,
    FormSection,
    RestFormItem,
    EnumSelect,
    DummySms,
    Mobivate,
    Facebook,
    MessageBird,
    MessageBirdWhatsapp,
    Tola,
    Twilio,
    Phonovation,
    Ssc,
    Mitto,
    Vonage,
    Sinch,
    SmsStudio,
    Smpp,
    EngageHub,
    Eyou
  },

  props: {
    readonly: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      channelOptionLabel,
      channelOptionComponentName,
      model: this.defaultModel()
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'get',
          url: `channel-configs/${this.$route.query.id}`,
          handler: data => {
            this.model = data
          }
        })
      } else {
        return null
      }
    },

    saveEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'patch',
          url: `channel-configs/${this.$route.query.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: `channel-configs`
        })
      }
    },

    isCreatePage() {
      return !this.$route.query.id
    }
  },

  created() {
    if (this.isCreatePage) {
      this.$set(this.model, 'project_id', this.$route.query.project_id)
      this.$set(this.model, 'active', 0)
    }
  },

  methods: {
    defaultModel() {
      if (this.$route.query.id) {
        return null
      } else {
        return {}
      }
    },

    afterSave() {
      this.$router.push(
        projectRoute({
          name: 'ChannelList'
        })
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/pages/ChannelFormPage.vue